import React from "react";
import { ProfileManageContextProvider } from "./ProfileInfoView";
import ProfileInfo from "./views/ProfileInfo";

const ProfileManageListPage = () => {
  return (
    <div>
      <ProfileManageContextProvider>
        <ProfileInfo />
      </ProfileManageContextProvider>
    </div>
  );
};
export default ProfileManageListPage;
